// locations/practices - locations.js
export const FETCH_QUESTIONS = 'FETCH_QUESTIONS'
export const FETCH_QUESTIONS_SUCCESS = 'FETCH_QUESTIONS_SUCCESS'
export const FETCH_QUESTIONS_FAILURE = 'FETCH_QUESTIONS_FAILURE'
export const UPDATE_QUESTIONS = 'UPDATE_QUESTIONS'
export const CLEAR_QUESTIONS = 'CLEAR_QUESTIONS'

export const FETCH_ANSWERS = 'FETCH_ANSWERS'
export const UPDATE_ANSWERS = 'UPDATE_ANSWERS'
export const CLEAR_ANSWERS = 'CLEAR_ANSWERS'
export const ADD_ANSWER = 'ADD_ANSWER'

export const UPDATE_SECTIONS = 'UPDATE_SECTIONS'
export const CLEAR_SECTIONS = 'CLEAR_SECTIONS'



// WEBPACK FOOTER //
// ./resources/assets/js/frontend-vue/store/mutation-types.js